/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  StartOnboardingRequestBody,
  StartOnboardingRequestBody$Outbound,
  StartOnboardingRequestBody$outboundSchema,
} from "../components/startonboardingrequestbody.js";

export type StartPlatformMCPOnboardingSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type StartPlatformMCPOnboardingRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  startOnboardingRequestBody: StartOnboardingRequestBody;
};

/** @internal */
export type StartPlatformMCPOnboardingSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const StartPlatformMCPOnboardingSecurity$outboundSchema: z.ZodMiniType<
  StartPlatformMCPOnboardingSecurity$Outbound,
  StartPlatformMCPOnboardingSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function startPlatformMCPOnboardingSecurityToJSON(
  startPlatformMCPOnboardingSecurity: StartPlatformMCPOnboardingSecurity,
): string {
  return JSON.stringify(
    StartPlatformMCPOnboardingSecurity$outboundSchema.parse(
      startPlatformMCPOnboardingSecurity,
    ),
  );
}

/** @internal */
export type StartPlatformMCPOnboardingRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  StartOnboardingRequestBody: StartOnboardingRequestBody$Outbound;
};

/** @internal */
export const StartPlatformMCPOnboardingRequest$outboundSchema: z.ZodMiniType<
  StartPlatformMCPOnboardingRequest$Outbound,
  StartPlatformMCPOnboardingRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    startOnboardingRequestBody: StartOnboardingRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      startOnboardingRequestBody: "StartOnboardingRequestBody",
    });
  }),
);

export function startPlatformMCPOnboardingRequestToJSON(
  startPlatformMCPOnboardingRequest: StartPlatformMCPOnboardingRequest,
): string {
  return JSON.stringify(
    StartPlatformMCPOnboardingRequest$outboundSchema.parse(
      startPlatformMCPOnboardingRequest,
    ),
  );
}
